import React from 'react';
import PropTypes from 'prop-types';
import { RowStyle } from './Styled';

const DivRow = ({ children, noGutters, className, style }) => {
  className = `${className} ${noGutters ? 'no-gutters' : ''}`;
  return (
    <RowStyle style={style} className={className}>
      {children}
    </RowStyle>
  );
};

DivRow.defaultProps = {
  noGutters: false,
  className: '',
  style: {},
};

DivRow.prototypes = {
  noGutters: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
};

const Row = React.memo(DivRow);

export default Row;
export { Row };
